import { jsx, jsxs } from 'react/jsx-runtime';
import CloseIcon from '@mui/icons-material/Close';
import { styled, Dialog, Slide, useMediaQuery, Fade, DialogTitle, Icon, DialogContent } from '@mui/material';
import React__default from 'react';
import { brandclubStyles } from '../../../styles/index.js';
import { DIALOG_SCREEN_SIZE, TABLET_SCREEN_SIZE } from '../../../utils/constants/Constants.js';

const StyledDialog = styled(Dialog)(({ theme }) => ({
    '&.popup-drawer': {
        '& div.MuiDialog-paper': {
            margin: 0,
            borderRadius: 10,
            minWidth: 569,
            maxWidth: 569,
            minHeight: 400,
            color: theme.vars.palette.text.primary,
            boxShadow: 'none',
        },
        '& h2.MuiDialogTitle-root': {
            padding: '12px 13px',
        },
        '& .close-icon': {
            float: 'right',
            display: 'flex',
            width: 24,
            height: 24,
            color: theme.vars.palette.text.primary,
            cursor: 'pointer',
            position: 'relative',
            top: 7,
            right: 7,
        },
        '& .dialog-content': Object.assign({ padding: 0, overflowY: 'auto', color: theme.vars.palette.text.primary }, brandclubStyles.customScrollbar),
        // media queries
        [`@media screen and (max-width: ${DIALOG_SCREEN_SIZE}px)`]: {
            '& div.MuiDialog-paper': {
                width: '100vw',
                minWidth: '100vw',
                maxWidth: '100vw',
                maxHeight: '75vh',
                position: 'absolute',
                bottom: 0,
            },
        },
    },
}));
const SlideUpTransition = React__default.forwardRef(function Transition(props, ref) {
    return jsx(Slide, Object.assign({ direction: "up", ref: ref }, props));
});
/**
 * @returns dialog that turn into bottom drawer when viewport < TABLET_SCREEN_SIZE
 */
const PopupDrawer = ({ open, onClose, dialogProps, children }) => {
    const desktopView = useMediaQuery(`(min-width:${TABLET_SCREEN_SIZE}px)`);
    const handleCloseDialog = () => onClose();
    return (jsxs(StyledDialog, Object.assign({ open: open, className: "popup-drawer", onClose: handleCloseDialog, TransitionComponent: desktopView ? Fade : SlideUpTransition }, dialogProps, { children: [jsx(DialogTitle, { children: jsx(Icon, Object.assign({ className: "close-icon", onClick: handleCloseDialog }, { children: jsx(CloseIcon, { sx: {
                            width: '100%',
                            height: '100%',
                        } }) })) }), jsx(DialogContent, Object.assign({ className: "dialog-content" }, { children: children }))] })));
};

export { PopupDrawer };
//# sourceMappingURL=PopupDrawer.js.map
